import React, { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
// import moment from "moment";
import MetaTags from "react-meta-tags";

import {
  ErrorMessage,
  Loading,
  SettingsBillingForm,
  SettingsPersonalForm,
} from "../../components";
import RepledgeModal from "../../components/Modals/RepledgeModal";
// import * as Bpoint from "../../api/Bpoint";

import "../../styles/pages/_settings.scss";
import moment from "moment";

function Settings() {
  const {
    directDebit,
    creditCard,
    details,
    settingsLoading,
    settingsError,
    ...rest
  } = useSelector((state) => state.settings);

  const [showRebillModal, setShowRebillModal] = useState(false);

  const handleExpiredCard = useCallback(
    (newCreditCardId) => {
      if (moment(creditCard.expiry_date, "YYYY-MM").isBefore(moment(), "M")) {
        setShowRebillModal(true);
      }
    },
    [creditCard]
  );

  const initialValues = useMemo(() => {
    const directDebitRefactor = {
      direct_debit_name: directDebit.name || "",
      direct_debit_bsb: directDebit.bsb || "",
      direct_debit_number: "",
      masked_direct_debit_number: directDebit.number_masked || "",
    };
    const creditCardRefactor = {
      credit_card_name: creditCard.name || "",
      masked_credit_card_number: creditCard.number_masked || "",
      credit_card_number: "",
      credit_card_expiry_date: creditCard.expiry_date
        ? moment(creditCard.expiry_date, "YYYY-MM").format("MM/YY")
        : "",
      credit_card_ccv: "",
    };
    return {
      ...directDebitRefactor,
      ...creditCardRefactor,
      terms_agree: false,
      email: details.email,
      user_id: details.user_id,
      _credit_card_name: creditCardRefactor.credit_card_name,
      _credit_card_expiry_date: creditCardRefactor.credit_card_expiry_date,
      _direct_debit_name: directDebitRefactor.direct_debit_name,
      _direct_debit_bsb: directDebitRefactor.direct_debit_bsb,
    };
  }, [directDebit, creditCard, details]);

  if (settingsLoading) {
    return <Loading />;
  }

  if (settingsError) {
    return <ErrorMessage title={settingsError} />;
  }

  return (
    <div>
      <MetaTags>
        <title>
          AFES - {details?.organisation_name ? "Organisation" : "Personal"}{" "}
          Settings
        </title>
      </MetaTags>

      {showRebillModal && (
        <RepledgeModal onClose={() => setShowRebillModal(false)} />
      )}

      <h1 className="white">
        {details?.organisation_name ? "Organisation" : "Personal"} Details
      </h1>
      <div className="settings">
        <div className="settings__block settings--personal">
          <SettingsPersonalForm />
        </div>
        <div className="settings__block settings--billing">
          <SettingsBillingForm
            initialValues={initialValues}
            handleExpiredCard={handleExpiredCard}
          />
        </div>
      </div>
    </div>
  );
}

export default Settings;
